import React, { useEffect, useState } from 'react';
import { Loader2, Mail, Save } from 'lucide-react';
import { salesApi } from '../api';

const fmt = (v) => {
  if (!v) return '';
  const d = new Date(/Z|[+-]\d\d:\d\d$/.test(v) ? v : `${v}Z`);
  return d.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) + ' IST';
};

export default function ErpDigestCard({ theme }) {
  const [recipients, setRecipients] = useState('');
  const [last, setLast] = useState(null);
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState({ ok: true, text: '' });

  const load = () => salesApi.erpDigest().then(d => { setRecipients((d.recipients || []).join(', ')); setLast(d.last); }).catch(() => {});
  useEffect(() => { load(); }, []);

  const run = async (kind, fn, okText) => {
    setBusy(kind); setMsg({ ok: true, text: '' });
    try { const r = await fn(); setMsg({ ok: true, text: okText(r) }); load(); }
    catch (e) { setMsg({ ok: false, text: e.response?.data?.detail || 'Something went wrong' }); }
    finally { setBusy(''); }
  };
  const save = () => run('save', () => salesApi.saveErpDigest(recipients), () => 'Recipients saved');
  const sendNow = () => {
    if (!window.confirm("Send last week's ERP digest now?")) return;
    run('send', salesApi.sendErpDigestNow, r => (r.status === 'sent' ? `Digest sent (${r.errorRows} failed rows)` : `Not sent: ${r.error}`));
  };

  return (
    <div className="mb-4 p-4 rounded-md border border-[#EFEADB] bg-white" data-testid="erp-digest-card">
      <div className="flex items-center gap-2 text-[13.5px] font-medium"><Mail size={15} /> Weekly ERP digest</div>
      <p className="text-[12.5px] text-[#7a6f5c] mt-1 mb-3">Every Monday 9 AM IST, last week's failed sales rows are emailed as Excel (or an "all clear" note). Super Admins are always CC'd. Leave blank to send only to Super Admins.</p>
      <div className="flex flex-wrap items-center gap-2">
        <input value={recipients} onChange={e => setRecipients(e.target.value)} placeholder="erp.team@futuremakeup.com, it@futuremakeup.com"
          data-testid="erp-digest-recipients-input" className="fm-focus flex-1 min-w-[280px] border border-[#E7E2D3] rounded-md px-3 py-2 text-[13px] bg-white" />
        <button onClick={save} disabled={!!busy} data-testid="erp-digest-save-btn" className="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-[#E7E2D3] bg-white text-[13px] hover:bg-[#F7F4EA] disabled:opacity-50">
          {busy === 'save' ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save
        </button>
        <button onClick={sendNow} disabled={!!busy} data-testid="erp-digest-send-now-btn" className="inline-flex items-center gap-2 px-3 py-2 rounded-md text-white text-[13px] font-medium disabled:opacity-50" style={{ background: theme.primary }}>
          {busy === 'send' ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />} Send last week now
        </button>
      </div>
      {msg.text && <div data-testid="erp-digest-msg" className={`mt-2 text-[12.5px] ${msg.ok ? 'text-[#2f6b41]' : 'text-[#9b2c1f]'}`}>{msg.text}</div>}
      {last && (
        <div data-testid="erp-digest-last" className="mt-2 text-[12px] text-[#7a6f5c]">
          Last digest: {fmt(last.sentAt)} · {last.status} · {last.errorRows} failed rows · week of {last.weekStart}{last.error ? ` · ${last.error}` : ''}
        </div>
      )}
    </div>
  );
}
